import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import WithApa from 'newComponents/WithApa/WithApa';
import { GetRegion } from 'constants.js';
import { Form } from 'cvlib';
import { setMetricsEvent } from 'action-creators/metrics';
import { UserContext } from 'providers/user.provider';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { pushGTMEvent } from 'containers/Player/utils/analytics';
import { showModal } from '../../actions/response';
import { METRICS as m } from './constants';

import './Landing.scss';
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import getQueryParameter from 'utils/nav/getQueryParameter';
import useMenuRedirect from '../Menu/hooks/useMenuRedirect';
import ModalFactory from 'components/modal/ModalFactory';

const LandingPage = ({ asset, translations }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    landing_menu_title_label,
    landing_menu_description_label,
    landing_menu_option_button_register,
    landing_menu_option_button_login,
    landing_menu_option_button_anonymous,
    landing_menu_promotionalCode_label_link,
    telmex_chat_text,
    telmex_chat_link,
    landing_menu_iptelmexDescription_label,
    landing_menu_iptelmexLogin_button,
    landing_menu_iptelmexClarification_label,
  } = translations;

  const { landing_head_logoClarovideo } = asset;
  const dispatch = useDispatch();
  const modal = useSelector(state => state?.modal);
  const renderNetModal = () => ModalFactory.create(modal);
  const { nodes, handleRedirect } = useMenuRedirect();

  const sendMetrics = params => {
    dispatch(
      setMetricsEvent({
        tagManager: {
          ...params,
        },
      }),
    );

    dispatch(
      setMetricsEvent({
        type: m.EXECUTOR,
        success: true,
      }),
    );
  };

  const pushLandingEvent = selection => {
    const metricsParams = {
      event: 'landing',
      selection,
      country: GetRegion(),
    };
    pushGTMEvent(metricsParams);
  };

  const onAnonymousClicked = () => {
    sendMetrics({
      event: m.EVENT.REGISTER,
      eventCategory: m.CATEGORY.LANDING,
      eventAction: m.ACTION.CLICK,
      eventLabel: m.LABEL.FREE_WATCH,
    });

    const anonymousUserComeFromPlayer = searchParams.get(
      'anonymousUserComeFromPlayer',
    );
    if (anonymousUserComeFromPlayer) {
      const urlVcard = searchParams.get('urlVcard');
      return navigate(urlVcard);
    }

    handleRedirect({ node: nodes?.[0] }, location);
  };

  const onRegisterClicked = () => {
    sendMetrics({
      event: m.EVENT.REGISTER,
      eventCategory: m.CATEGORY.LANDING,
      eventAction: m.ACTION.CLICK,
      eventLabel: m.LABEL.SING_UP,
    });
    pushLandingEvent('registrate');
    navigate(`/${GetRegion()}/register${location.search}`, { ...location });
  };

  const onLoginClicked = () => {
    if (GetRegion().indexOf('brasil') !== -1) {
      const modal = {
        modalType: 'NetVendors',
      };
      dispatch(showModal(modal));
      return;
    }
    sendMetrics({
      event: m.EVENT.REGISTER,
      eventCategory: m.CATEGORY.LANDING,
      eventAction: m.ACTION.CLICK,
      eventLabel: m.LABEL.LOG_IN,
    });
    pushLandingEvent('inicia_sesion');
    navigate(`/${GetRegion()}/login${location.search}`, { ...location });
  };

  const onChatClicked = () => {
    window.open(telmex_chat_link);
  };

  const redirectToRegisterWithPromoGate = () => {
    navigate(
      `/${GetRegion()}/register?${createSearchParams({ isPromoGate: true })}`,
      {
        ...location,
      },
    );
  };

  const elements = [
    {
      element: 'logo',
      content: landing_head_logoClarovideo,
      position: 'center',
      className: 'flexGrowZero landingLogo',
    },
    {
      element: 'title',
      content: landing_menu_title_label,
      position: 'center',
      className: 'flexGrowZero landingTitle',
    },
    {
      element: 'subtitle',
      content: landing_menu_description_label,
      className: 'flexGrowZero landingSubtitle',
    },
    {
      element: 'button',
      type: 'register',
      content: landing_menu_option_button_register,
      onClick: onRegisterClicked,
      id: 'btn_register_ld',
      className: 'flexGrowZero landingRegisterBtn',
    },
    {
      element: 'button',
      type: 'login',
      content: landing_menu_option_button_login,
      onClick: onLoginClicked,
      id: 'btn_starts_ld',
      className: 'flexGrowZero landingLoginBtn',
    },
    {
      element: 'button',
      type: 'anonymous',
      content: landing_menu_option_button_anonymous,
      onClick: onAnonymousClicked,
      id: 'btn_show_free_ld',
      className: 'flexGrowZero landingAnonymousBtn',
    },
    {
      element: 'message',
      content: landing_menu_promotionalCode_label_link,
      onClick: redirectToRegisterWithPromoGate,
      position: 'bottom',
      className: 'landingPromoMessage',
      expand: 0.01,
    },
    GetRegion() === 'mexico' && {
      element: 'message',
      content: telmex_chat_text,
      position: 'bottom',
      onClick: onChatClicked,
      expand: 0.01,
      className: 'landingChatMessage',
    },
  ];

  const {
    landing_head_logoClarovideo: cvLogo,
    landing_access_background: backgroundImage,
  } = asset;

  return (
    <>
      {renderNetModal()}
      <header className="landingHeader">
        <a
          href={`/${GetRegion()}/landing${location.search}${location.hash}`}
          onClick={event => {
            event.preventDefault();
            navigate(`/${GetRegion()}/landing${location.search}`, {
              ...location,
            });
          }}
        >
          <img src={cvLogo} alt="logo" />
        </a>
      </header>
      <div
        className="background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="landingPage">
        <div>
          <Form elements={elements} classes={['formLanding']} />
        </div>
      </div>
    </>
  );
};

LandingPage.propTypes = {
  asset: PropTypes.object,
  translations: PropTypes.object,
};

export default WithApa(LandingPage);
